import React from 'react';
import PropTypes from 'prop-types';
import HomePage from '../components/Views/HomePage';
import { getSeoData } from '../utils/helpers';
import Layout from '../components/Layout/Layout';

const App = ({ statusCode, seoData }) => (
  <HomePage {...{ statusCode, seoData }} />
);

App.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

App.propTypes = {
  statusCode: PropTypes.number,
  seoData: PropTypes.object
};

App.getLayout = page => <Layout isHomePage={true}>{page}</Layout>;

export default App;
